// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nq-1";
export var messageSideRight = "_nq-2";
export var orderLookupBubbleContainer = "_nq-0";
export var submitButton = "_nq-3";